import { updateDappFormSchema } from '../../../lib/schemas/formSchemas';

export const FORM_ID = 'dapp-update-form';
export const UpdateDappFormData = updateDappFormSchema;
